import { Type } from "class-transformer";
import { UserHeader } from "../models/user";

export enum NoteType
{
    Sticky,
    Finance,
    Nurse,
    Manager
}

export interface INote
{
    id: number,
    subject: string,
    body: string,
    createDate: Date,
    createdBy: UserHeader,
    noteTypes: number[]
}

export class NoteAddendum
{
    constructor
    (
        public id: number,
        public noteId: number,
        public body: string,
        public createdBy: UserHeader,
        public createDate: Date
    )
    {}
}

export class NoteAddendumInsert
{
    constructor(public body: string) {}
}

export class Note implements INote
{
    constructor
    (
        public id: number,
        public subject: string,
        public body: string,
        public createDate: Date,
        public createdBy: UserHeader,
        public noteTypes: number[]
    )
    {

    }

    @Type(() => NoteAddendum)
    addenda: NoteAddendum[] = [];
}

export class NoteUpdate
{
    constructor
    (
        public noteId:number
    )
    {

    }
    subject?: string;
    body?: string;
    noteTypes?:number[];
}

export class NoteInsert
{
    constructor
    (
        public subject: string,
        public body: string,
        public createdById: number,

    )
    {

    }
    noteTypes?:number[];
}